import { getTypeaheadCategoryEntry } from 'Src/utils/getTypeaheadCategoryEntry';
import { NO_RESULTS_LINKS_BASE_QUERY_MODS } from './constants';

export const getCommonSearchMessageDescriptor = (searchTerm: string) => {
  const searchTermId = searchTerm.trim().toLowerCase().replace(/\s+/g, '_');
  const defaultMessage = searchTerm === '' ? 'See all providers' : searchTerm;
  return {
    id: `common_search.term.${searchTermId}`,
    defaultMessage: defaultMessage,
    description: 'Chip label for common search chips on no results page'
  };
};

export const getBaseQueryMods = ({
  queryParams
}: {
  queryParams: URLSearchParams;
}) => {
  const queryMods = [...NO_RESULTS_LINKS_BASE_QUERY_MODS];
  const typeaheadCategoryEntry = getTypeaheadCategoryEntry(queryParams);
  if (typeaheadCategoryEntry) {
    queryMods.push({
      action: 'delete_key',
      key: typeaheadCategoryEntry[0]
    });
  }
  return queryMods;
};
